let formBase = {
    'Topic': { 'name': 'Topic', 'required': true, 'data': '' },

    'first_name': { 'name': 'First Name', 'required': true, 'data': '' },
    'last_name': { 'name': 'Last Name', 'required': true, 'data': '' },
    'e-mail': { 'name': 'E-mail', 'required': true, 'data': '' },
    'email': { 'name': 'E-mail', 'required': true, 'data': '' },
    'e-mailRaI': { 'name': 'E-mail', 'required': true, 'data': '' },
    'phone': { 'name': 'Phone', 'required': false, 'data': '' },
    'customer_number': { 'name': 'Your customer number', 'required': false, 'data': '' },
    'uin': { 'name': 'UIN', 'required': false, 'data': '' },
    'city': { 'name': 'City', 'required': false, 'data': '' },
    'min_deposit': { 'name': 'min_deposit', 'required': false, 'data': '' },
    'role': { 'name': 'role', 'required': false, 'data': '' },
    'net_worth': { 'name': 'net_worth', 'required': false, 'data': '' },
    'deposit': { 'name': 'deposit', 'required': false, 'data': '' },
    'interest': { 'name': 'interest', 'required': false, 'data': '' },
    'contact_preference': { 'name': 'contact_preference', 'required': false, 'data': '' },
    'linkedin_profile': { 'name': 'linkedin_profile', 'required': false, 'data': '' },
    'website': { 'name': 'website', 'required': false, 'data': '' },
    'clear_Screen_Shot': { 'name': 'clear_Screen_Shot', 'required': false, 'data': '' },

    'message': { 'name': 'Message', 'required': true, 'data': '' },
    'messageCb': { 'name': 'Message', 'required': true, 'data': '' },
    'messageRaI': { 'name': 'Message', 'required': true, 'data': '' },
    'other_purpose': { 'name': 'Message', 'required': true, 'data': '' },
    'role_other_specify': { 'name': 'Message', 'required': true, 'data': '' },
    'interest_other_specify': { 'name': 'Message', 'required': true, 'data': '' },

    'multi-currency-account': { 'name': 'multi-currency-account', 'required': true, 'data': '' },
    'title': { 'name': 'title', 'required': true, 'data': '' },
    'country-priv': { 'name': 'country-priv', 'required': true, 'data': '' },
    'request-purpose': { 'name': 'request-purpose', 'required': true, 'data': '' },
    'sector': { 'name': 'sector', 'required': true, 'data': '' },

    'count-inc': { 'name': 'Country', 'required': true, 'data': '' },
};
let formValid = false;

document.addEventListener('DOMContentLoaded', () => {
    'use strict';

    console.log('form.js loaded');

    let $formFields = $('.box-form input,.box-form select,.box-form textarea');

    if ($('.box-form')[0] !== undefined) {

        // focus / фокус
        document.addEventListener(
            'focusin',                             // bubbles / всплывает
            (e) => {
                const box = e.target.closest('.box-form');
                if (box) {
                    box.classList.add('active', 'focus');
                }
            },
            true
        );

        // blur / потеря фокуса
        document.addEventListener(
            'focusout',
            (e) => {
                const el  = e.target;
                const box = el.closest('.box-form');
                if (!box) return;

                if ((el.value === '' || el.value === false) && !el.classList.contains('srvl')) {
                    box.classList.remove('active');
                }
                box.classList.remove('focus');
            },
            true
        );

        $('#srvl').on('update change mouseup focus input blur ', function () {
            if ($('#busmod').val() === '') {
                $('#businessFormDropDown').addClass("dd__Error");
            }
            else {
                $('#businessFormDropDown').removeClass("dd__Error");
            }
        });


        $formFields.on('change keyup', function () {

            if ($(this).attr('required') !== undefined) {
                if ($(this)[0].checkValidity()) {
                    $(this).parents('.box-form,.checkbox,.radio').removeClass("error");
                    // console.log("remove error");
                }
                else {
                    $(this).parents('.box-form,.checkbox,.radio').addClass("error");
                    // console.log("add error");
                }
            }

        });

    }

    // console.log('start form1');
    // if($(window).width() > 1023) {
    // $("select.nosrch").select2({minimumResultsForSearch: Infinity});
    // $("select.select").select2();

    let siteHost = 'https://' + location.host + '/';



    if ($("#phone")[0]) {
        try {
            $("#phone").intlTelInput({
                formatOnDisplay: true,
                geoIpLookup: function (callback) {
                    $.get("//ipinfo.io", function () { }, "jsonp").always(function (resp) {
                        var countryCode = (resp && resp.country) ? resp.country : "";
                        callback(countryCode);
                    });
                },
                hiddenInput: "full_number",
                initialCountry: "auto",
                nationalMode: false,
                preferredCountries: ['gb', 'ch', 'de', 'ua'],
                separateDialCode: false,
                utilsScript: siteHost + "js/utils.js"
            });
        } catch (e) {
            console.log(e)
        }
    }

    if ($("#phoneCb")[0]) {
        try {
            $("#phoneCb").intlTelInput({
                formatOnDisplay: true,
                geoIpLookup: function (callback) {
                    $.get("//ipinfo.io", function () { }, "jsonp").always(function (resp) {
                        var countryCode = (resp && resp.country) ? resp.country : "";
                        callback(countryCode);
                    });
                },
                hiddenInput: "full_number",
                initialCountry: "auto",
                nationalMode: false,
                preferredCountries: ['gb', 'ch', 'de', 'ua'],
                separateDialCode: false,
                utilsScript: siteHost + "js/utils.js"
            });
        } catch (e) {
            console.log(e)
        }
    }

    if ($("#phoneRaI")[0]) {
        try {
            $("#phoneRaI").intlTelInput({
                formatOnDisplay: true,
                geoIpLookup: function (callback) {
                    $.get("//ipinfo.io", function () { }, "jsonp").always(function (resp) {
                        var countryCode = (resp && resp.country) ? resp.country : "";
                        callback(countryCode);
                    });
                },
                hiddenInput: "full_number",
                initialCountry: "auto",
                nationalMode: false,
                preferredCountries: ['gb', 'ch', 'de', 'ua'],
                separateDialCode: false,
                utilsScript: siteHost + "js/utils.js"
            });
        } catch (e) {
            console.log(e)
        }
    }

    if ($("#contact_number")[0]) {
        try {
            $("#contact_number").intlTelInput({
                formatOnDisplay: true,
                geoIpLookup: function (callback) {
                    $.get("//ipinfo.io", function () { }, "jsonp").always(function (resp) {
                        var countryCode = (resp && resp.country) ? resp.country : "";
                        callback(countryCode);
                    });
                },
                hiddenInput: "full_number",
                initialCountry: "auto",
                nationalMode: false,
                preferredCountries: ['gb', 'ch', 'de', 'ua'],
                separateDialCode: false,
                utilsScript: siteHost + "js/utils.js"
            });
        } catch (e) {
            console.log(e)
        }
    }

    // $formFields.on('change keyup input',function () {
    //
    //     if($(this).attr('id').indexOf('3') === -1) {
    //         $(this).parents('.box-form').addClass("active");
    //
    //         if($(this).val()==='' || $(this).val()===false){
    //             $(this).parents('.box-form').addClass("error");
    //         } else $(this).parents('.box-form').removeClass("error");
    //     }
    // });

    // $('.first-step .box-form input,.first-step .box-form select,.first-step .box-form textarea').on('change keyup input', function () {
    //     // $(this).parents('.box-form').addClass("active");
    //
    //
    //     // let baidat = false;
    //     // let patt = /а-яА-ЯёЁa-zA-Z0-9/;
    //     // валидация данных
    //     //
    //
    //     // if ($(this).val() === '' || $(this).val() === false) formBase[$(this).attr('name')]['data'] = false;
    //
    //     // else $(this).parents('.box-form').removeClass("error");
    //
    //     // if ($(this).attr('name') === 'Topic'
    //     //     || $(this).attr('name') === 'first_name'
    //     //     || $(this).attr('name') === 'last_name') {// обработка mcanumber
    //     //
    //     //     //Валидация
    //     //     patt = /^(([а-яА-ЯёЁA-Za-z]+[\s\-\']?)*([а-яА-ЯёЁA-Za-z]+)?)$/;
    //     //     if (!patt.test($(this).val())) {
    //     //         baidat = false;
    //     //         formBase[$(this).attr('name')]['data'] = false;
    //     //         $(this).parents('.box-form').addClass("error");
    //     //     }
    //     //     else {
    //     //         $(this).parents('.box-form').removeClass("error");
    //     //         baidat = $(this).val();
    //     //     }
    //     //     if ($('#Topic').val() === null) $('#Topic').parents('.box-form').addClass("error");
    //     //
    //     // } else if ($(this).attr('name') === 'e-mail') {// обработка email
    //     //
    //     //     //Валидация
    //     //     patt = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    //     //     if (!patt.test($(this).val())) {
    //     //         formBase[$(this).attr('name')]['data'] = false;
    //     //         baidat = false;
    //     //         $(this).parents('.box-form').addClass("error");
    //     //     }
    //     //     else {
    //     //         $(this).parents('.box-form').removeClass("error");
    //     //         baidat = $(this).val();
    //     //     }
    //     //
    //     // } else if ($(this).attr('name') === 'phone') {// обработка phone
    //     //
    //     //     //Валидация
    //     //     patt = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    //     //     if (!patt.test($(this).val())) {
    //     //         formBase[$(this).attr('name')]['data'] = false;
    //     //         baidat = false;
    //     //         $(this).parents('.box-form').addClass("error");
    //     //     }
    //     //     else {
    //     //         $(this).parents('.box-form').removeClass("error");
    //     //         baidat = $(this).val();
    //     //     }
    //     //
    //     // }
    //     let baidat = $(this).val();
    //
    //     if(!!formBase[$(this).attr('name')]['data']) {
    //         console.log(formBase[$(this).attr('name')]['data']);
    //         formBase[$(this).attr('name')]['data'] = baidat;
    //         formBase[$(this).attr('name')]['name'] = $(this).attr('data-name');
    //     }
    //
    //     for (let prop in formBase) {
    //         if ((formBase[prop].data === false || formBase[prop].data === '') && formBase[prop].required === true) {
    //             formValid = false;
    //             break
    //         }
    //         else formValid = true;
    //         // console.log('formValid === false (' + formBase[prop].data + ') -> ' + formBase[prop].required);
    //     }
    //     if (formValid === true) {
    //         // $('#contactFormSubmitBTN').removeClass('disabled').prop('disabled',false);
    //         // localStorage.removeItem('form-data');
    //         // localStorage.setItem("form-data",JSON.stringify(formBase));
    //         // console.log('formValid === true');
    //
    //     }
    //     // else $('#contactFormSubmitBTN').addClass('disabled').prop('disabled',true);
    //     // console.log(formBase[$(this).attr('name')]['name']+' -> '+baidat);
    //
    //
    // });

    $('#contactFormSubmitBTN').on('click', function () {
        for (let prop in formBase) {
            if ((formBase[prop].data === false || formBase[prop].data === '') && formBase[prop].required === true) {
                $('#' + prop).parents('.box-form').addClass("error");
                $('#' + prop).val();
                // $('#contactFormSubmitBTN').addClass('disabled');
            }
        }
    });


    // delegate input / делегируем input
    document.addEventListener('input', (e) => {
        if (e.target.tagName === 'TEXTAREA') {
            syncTextareaWithDiv($(e.target)); // ← одразу jQuery-об’єкт
        }
    }, true);

    // initial sync / начальная синхронизация
    $('textarea').each(function () {
        syncTextareaWithDiv($(this));
    });

});

function syncTextareaWithDiv($textarea) {
    // console.log($textarea);
    $textarea.prev().html($textarea.val().replace(/\r?\n$/g, '<br><br>').replace(/\r?\n/g, '<br>'));
}

function onSubmit(token) {

    if (formValid) {
        $('#contactFormSubmitBTN').prop('disabled', true);
        let form = $('#contact-form');
        let url = form.attr('action');
        // $('#contactFormErrMsg').fadeOut();
        $('.loader').addClass('loading');

        $.ajax({
            type: "POST",
            url: url,
            data: form.serialize(), // serializes the form's elements.
            success: function (data) {
                let response = JSON.parse(data);

                if (response.result == 'OK') {
                    // document.getElementById("contactFormContainer")
                    //     .classList.add('success');
                    // .innerHTML = "<h3 style='color: #00ad65'>Your request was successfully submitted</h3>";
                    $('.first-step').fadeOut(300);
                    setTimeout(() => {
                        $('.last-window').fadeIn(300);
                        $('#contactFormContainer').addClass('success').parents('.modal-dialog').addClass('vrcntr');
                    }, 300);


                }
                else {
                    // $('#contactFormErrMsg').fadeIn();
                    //console.log('response.result == \'false\'');
                }
                $('#contactFormSubmitBTN').prop('disabled', false);
                //console.log('success');

            },
            error: function () {
                $('#contactFormSubmitBTN').prop('disabled', false);
                //console.log('error');
                $('.loader').removeClass('loading');
            }
        });
    }

}

const formStatus = (name,status='success') => {
    const el = document.getElementById(name);
    if (status === 'error') {
        el.querySelector('.first-step').style.display = 'none';
        setTimeout(() => {
            el.querySelector('.error-window').style.display = 'block';
            el.classList.add('error');
        }, 300);
    } else if (status === 'normal') {
        el.querySelector('.last-window').style.display = 'none';
        el.querySelector('.error-window').style.display = 'none';
        el.querySelector('.first-step').style.display = 'block';
    } else {
        el.querySelector('.first-step').style.display = 'none';
        setTimeout(() => {
            el.querySelector('.last-window').style.display = 'block';
            el.classList.add('success');
        }, 300);
    }
}